<template>
  <div>
    <div :id="popoverId" class="font-weight-semi-bold cursor-pointer" @mouseover="loadTokens">
      {{ availableTokensCount }} AVAILABLE
    </div>

    <b-popover :target="popoverId" triggers="hover" placement="bottom">
      <div v-if="loading">Loading</div>
      <div v-else-if="tokenData" class="d-flex flex-column">
        <div><b>Status:</b> {{status || 'Active'}}</div>
        <div v-if="hasRenewal"><b>Start:</b> {{ validFrom }}</div>
        <div v-if="hasRenewal"><b>Renewal:</b> {{ validUntil }}</div>
        <div><b>Licenses:</b> {{ currentTokensCount }} Available</div>
        <div v-if="hasComposite"><b>Comps: </b> {{ tokenData.tokens.composite }} Available</div>
      </div>
    </b-popover>
  </div>

</template>

<script>
export default {
  props: ['availableTokensCount', 'status'],

  data() {
    return {
      loading: false,
      hasError: false,
      tokenData: null,
      popoverId: (Math.random() + 1).toString(36).substring(7)
    }
  },

  computed: {

    hasRenewal() {
      return this.status === 'ACTIVE'
    },

    validFrom() {
      if (!this.tokenData) { return null }
      return this.tokenData.valid_from
    },

    validUntil() {
      if (!this.tokenData) { return null }
      return this.tokenData.valid_until
    },

    hasComposite() {
      if (!this.tokenData) {
        return false
      }
      return this.tokenData.tokens.composite
    },
    currentTokensCount() {
      if (!this.tokenData) {
        return 0
      }

      const keys = Object.keys(this.tokenData.tokens)

      const nonCompositeKeys = keys.filter(k => k !== 'composite')
      return nonCompositeKeys.map(k => this.tokenData.tokens[k]).reduce((sum, el) => el + sum, 0)
    }
  },

  methods: {
    loadTokens() {
      if (this.loading || this.tokenData) {
        return
      }

      this.loading = true
      this.$http.get("/customers/subscriptions/grouped_tokens.json").then(result => {
        this.tokenData = result.data
        this.loading = false
      }, failure => {
        this.loading = false
      })
    }
  }
}
</script>